"use client";

import clsx from "clsx";
import {
  hasStudioEditableText,
  renderStudioEditableText,
} from "@/utils/blogMdxSource";

type RawHtmlSnippetProps = {
  html: string;
  caption?: unknown;
  className?: string;
};

/**
 * Renders trusted admin-authored HTML (embeds, iframes, etc.) inside a styled
 * container. Authored in Studio; rendered as-is on the public site.
 */
export function RawHtmlSnippet({
  html,
  caption,
  className,
}: Readonly<RawHtmlSnippetProps>) {
  const trimmed = html.trim();
  if (!trimmed) {
    return null;
  }

  return (
    <figure
      className={clsx(
        "not-prose w-full [&_iframe]:aspect-video [&_iframe]:w-full [&_iframe]:rounded-xl",
        className,
      )}
    >
      {/* Authored HTML is normalized by the browser (comments, implied tags). */}
      <div
        suppressHydrationWarning
        dangerouslySetInnerHTML={{ __html: trimmed }}
      />
      {hasStudioEditableText(caption) ? (
        <figcaption className="mt-3 text-center font-monument text-sm text-black/50">
          {renderStudioEditableText(caption)}
        </figcaption>
      ) : null}
    </figure>
  );
}
